"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZOID_VALIDATION_ENV_ERROR = exports.PROP_VALIDATION_ERROR = exports.E_COMMERCE_QA_URL = exports.E_COMMERCE_PROD_URL = exports.E_COMMERCE_LOCAL_URL = exports.E_COMMERCE_DEV_URL = exports.E_COMMERCE_AUTOMATION_URL = exports.ENV_QA = exports.ENV_PROD = exports.ENV_LOCAL = exports.ENV_DEV = exports.ENV_AUTOMATION = void 0;
var E_COMMERCE_DEV_URL = 'https://payments-orange-pay.payments-np.homedepot.com/';
exports.E_COMMERCE_DEV_URL = E_COMMERCE_DEV_URL;
var E_COMMERCE_QA_URL = 'https://payments-orange-pay.payments-stg.homedepot.com/';
exports.E_COMMERCE_QA_URL = E_COMMERCE_QA_URL;
var E_COMMERCE_PROD_URL = 'https://payments-orange-pay.hdpayments.homedepot.com/';
exports.E_COMMERCE_PROD_URL = E_COMMERCE_PROD_URL;
var E_COMMERCE_LOCAL_URL = 'http://localhost:3030';
exports.E_COMMERCE_LOCAL_URL = E_COMMERCE_LOCAL_URL;
var E_COMMERCE_AUTOMATION_URL = 'https://op-ecommerce-automation.apps-np.homedepot.com';
exports.E_COMMERCE_AUTOMATION_URL = E_COMMERCE_AUTOMATION_URL;
var ENV_LOCAL = 'LOCAL';
exports.ENV_LOCAL = ENV_LOCAL;
var ENV_DEV = 'DEV';
exports.ENV_DEV = ENV_DEV;
var ENV_QA = 'QA';
exports.ENV_QA = ENV_QA;
var ENV_AUTOMATION = 'AUTOMATION';
exports.ENV_AUTOMATION = ENV_AUTOMATION;
var ENV_PROD = 'PROD';
exports.ENV_PROD = ENV_PROD;
var ZOID_VALIDATION_ENV_ERROR = '1070';
exports.ZOID_VALIDATION_ENV_ERROR = ZOID_VALIDATION_ENV_ERROR;
var PROP_VALIDATION_ERROR = 'Prop validation error';
exports.PROP_VALIDATION_ERROR = PROP_VALIDATION_ERROR;